import { gql } from '@apollo/client'

export const DISPLAY_FRAGMENT = gql`
  fragment Display on Display {
    id
    name
    dateRemoved
    order
    store {
      id
      location {
        id
        name
      }
    }
    displayType {
      id
      name
    }
    image {
      id
      url
    }
    masterCategoryId
    planogram {
      id
      shapedUpcs
    }
  }
`
